export const version     = '2.0.0';
export const companyName = 'Stradivari-Altenburg';

export const ServerUrl = process.env.REACT_APP_SERVER_URL || 'http://localhost:5500';
export const ClientUrl = process.env.REACT_APP_CLIENT_URL || 'http://localhost:3000';
